import CoursesInDirectionRow from './courses-in-direction-row'

export default CoursesInDirectionRow
